import { render, staticRenderFns } from "./SalepointDetails.vue?vue&type=template&id=ac1b7c3e&scoped=true&"
import script from "./SalepointDetails.vue?vue&type=script&lang=js&"
export * from "./SalepointDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac1b7c3e",
  null
  
)

export default component.exports